import React from 'react';

export default function(props){
    return(
        <>
         <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </>
    )
}